import Default from './default';
// import FullscreenIntro from '../components/fullscreenIntro';

class Home extends Default {
	namespace = 'home';

	beforeLeave = (data) => {
		super.beforeLeave(data);
	}
	
	afterLeave = (data) => {
		super.afterLeave(data);
	}

	beforeEnter = (data) => {
		// console.log('beforeEnter');
		super.beforeEnter(data);
		// this.initFullscreenIntro();

	}

	afterEnter = (data) => {
		// console.log('home');
		super.afterEnter(data);
	}

	// initFullscreenIntro = () => {
	// 	// console.log('initFullscreenIntro');
	// 	const $fullscreenIntro = $('[data-fullscreen-intro="el"]');

	// 	if ($fullscreenIntro.length) {
	// 		new FullscreenIntro($fullscreenIntro);
	// 	}
	// }
}

export default new Home();
